import { defineMessages } from '@atlassian/jira-intl';

export const messages: {
	successTitleCopiedUrl: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	errorTitleCopiedUrl: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	errorDescriptionCopiedUrl: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	commandCommandLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	successTitleCopiedUrl: {
		id: 'command-palette-integration.initial-commands.use-copy-page-url.success-title-copied-url',
		defaultMessage: 'Page URL copied to clipboard',
		description:
			'Message shown to user when the copy page url command is successful in the command palette',
	},
	errorTitleCopiedUrl: {
		id: 'command-palette-integration.initial-commands.use-copy-page-url.error-title-copied-url',
		defaultMessage: "We couldn't copy the page URL",
		description:
			'Title shown in message to user when the copy page url command fails in the command palette',
	},
	errorDescriptionCopiedUrl: {
		id: 'command-palette-integration.initial-commands.use-copy-page-url.error-description-copied-url',
		defaultMessage: 'Please check your browser settings.',
		description:
			'Description shown in message to user when the copy page url command fails in the command palette',
	},
	commandCommandLabel: {
		id: 'command-palette-integration.initial-commands.use-copy-page-url.command-command-label',
		defaultMessage: 'Copy current page URL',
		description: 'Label shown to the user in the command palette for copying the page url',
	},
});
